// Pre-written translations for the site's fixed UI labels (buttons, headings,
// form fields, etc). English lives in UI_STRINGS in mock.js — this file only
// needs entries for every OTHER supported language. Falls back to English
// automatically for any key not listed here.

export const UI_TRANSLATIONS = {
  es: {
    book_a_tour: "Reservar un tour",
    book_now: "Reservar ahora",
    learn_more: "Saber más",
    see_itinerary: "Ver itinerario",
    choose_your_tour: "Elige tu tour",
    read_reviews: "Leer más de 7.030 reseñas",
    daily_departures: "SALIDAS DIARIAS · MÁX. 12 PERSONAS",
    hero_title: "El tour de Estambul que se siente como un día con un amigo local.",
    hero_sub: "Desde entrada sin colas en Santa Sofía hasta barrios escondidos en dos continentes.",
    about_eyebrow: "Sobre Real Istanbul Tours",
    about_title: "Tours en grupos pequeños en Estambul desde 2014.",
    tours_eyebrow: "Los tours perfectos para tu primera visita a Estambul",
    tours_title: "Cuatro formas inolvidables de vivir Estambul.",
    itinerary_eyebrow: "Lo que verás",
    itinerary_title: "El Casco Antiguo por la mañana, Kadıköy para el almuerzo.",
    guides_eyebrow: "Nuestros guías",
    guides_title: "Personas que realmente viven aquí.",
    stops_eyebrow: "Nuestras paradas",
    stops_title: "Lugares auténticos, elegidos con los años.",
    reviews_eyebrow: "Lo que más mencionan nuestros huéspedes",
    reviews_title: "Un resumen basado en más de 7.030 reseñas verificadas.",
    featured_eyebrow: "Destacado en YouTube",
    press_eyebrow: "Real Istanbul Tours aparece en",
    faq_eyebrow: "Preguntas frecuentes",
    faq_title: "Todo lo que estabas a punto de preguntar.",
    cta_title: "Ven con curiosidad. Nosotros nos encargamos del resto.",
    cta_sub: "Cuatro tours, una ciudad, infinitas experiencias. ¿No sabes cuál elegir? Explora todos nuestros tours en Estambul y encuentra el ideal para ti.",
    free_cancellation: "Cancelación gratuita hasta 24h antes",
    instant_confirmation: "Confirmación instantánea",
    no_booking_fees: "Reserva directa, sin comisiones",
    small_groups_max: "Grupos pequeños, máx. 12 personas",
    footer_tagline: "Tours en grupos pequeños en Estambul desde 2014. Descubre la ciudad con guías locales certificados, explora barrios auténticos y vive Estambul como un local. 4,9★ de más de 1.000 reseñas verificadas.",
    subscribe: "Suscribirse",
    contact_title: "Ponte en contacto.",
    contact_sub: "Preguntas sobre reservas, itinerarios personalizados o simplemente saludar. Respondemos en un día.",
    full_name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono (opcional)",
    subject: "Asunto",
    message: "Mensaje",
    send_message: "Enviar mensaje",
    book_this_tour: "Reservar este tour",
    tour_date: "Fecha del tour",
    guests: "Número de personas",
    special_requests: "Solicitudes especiales (opcional)",
    submit_booking: "Enviar solicitud de reserva",
    blog_title: "Historias de Estambul.",
    blog_sub: "Guías, gastronomía a fondo y crónicas de barrio de nuestro equipo.",
    read_article: "Leer artículo",
  },
  ru: {
    book_a_tour: "Забронировать тур",
    book_now: "Забронировать сейчас",
    learn_more: "Узнать больше",
    see_itinerary: "Смотреть маршрут",
    choose_your_tour: "Выберите тур",
    read_reviews: "Более 7 030 отзывов",
    daily_departures: "ЕЖЕДНЕВНЫЕ ТУРЫ · МАКС. 12 ЧЕЛОВЕК",
    hero_title: "Тур по Стамбулу, который ощущается как день с местным другом.",
    hero_sub: "От входа без очереди в Айя-Софию до скрытых районов на двух континентах.",
    about_eyebrow: "О Real Istanbul Tours",
    about_title: "Туры в малых группах по Стамбулу с 2014 года.",
    tours_eyebrow: "Идеальные туры для первого визита в Стамбул",
    tours_title: "Четыре незабываемых способа увидеть Стамбул.",
    itinerary_eyebrow: "Что вы увидите",
    itinerary_title: "Старый город утром, Кадыкёй на обед.",
    guides_eyebrow: "Наши гиды",
    guides_title: "Люди, которые здесь действительно живут.",
    stops_eyebrow: "Наши остановки",
    stops_title: "Настоящие места, проверенные годами.",
    reviews_eyebrow: "Что гости отмечают снова и снова",
    reviews_title: "Обзор на основе более 7 030 проверенных отзывов гостей.",
    featured_eyebrow: "На YouTube",
    press_eyebrow: "Real Istanbul Tours упоминают",
    faq_eyebrow: "Частые вопросы",
    faq_title: "Всё, что вы хотели спросить.",
    cta_title: "Приходите с любопытством. Остальное — наша забота.",
    cta_sub: "Четыре тура, один город, бесконечные впечатления. Не знаете, что выбрать? Посмотрите все наши туры по Стамбулу и найдите свой идеальный вариант.",
    free_cancellation: "Бесплатная отмена за 24 часа",
    instant_confirmation: "Мгновенное подтверждение",
    no_booking_fees: "Прямое бронирование, без комиссий",
    small_groups_max: "Малые группы, макс. 12 человек",
    footer_tagline: "Туры в малых группах по Стамбулу с 2014 года. Откройте город с лицензированными местными гидами, исследуйте настоящие районы и почувствуйте Стамбул как местный житель. 4,9★ на основе более 1000 проверенных отзывов.",
    subscribe: "Подписаться",
    contact_title: "Свяжитесь с нами.",
    contact_sub: "Вопросы по бронированию, индивидуальные маршруты или просто поздороваться. Отвечаем в течение дня.",
    full_name: "Полное имя",
    email: "Эл. почта",
    phone: "Телефон (необязательно)",
    subject: "Тема",
    message: "Сообщение",
    send_message: "Отправить сообщение",
    book_this_tour: "Забронировать этот тур",
    tour_date: "Дата тура",
    guests: "Количество гостей",
    special_requests: "Особые пожелания (необязательно)",
    submit_booking: "Отправить заявку на бронирование",
    blog_title: "Истории из Стамбула.",
    blog_sub: "Гиды, гастрономические обзоры и очерки о районах от нашей команды.",
    read_article: "Читать статью",
  },
  it: {
    book_a_tour: "Prenota un tour",
    book_now: "Prenota ora",
    learn_more: "Scopri di più",
    see_itinerary: "Vedi itinerario",
    choose_your_tour: "Scegli il tuo tour",
    read_reviews: "Leggi oltre 7.030 recensioni",
    daily_departures: "PARTENZE GIORNALIERE · MAX 12 PERSONE",
    hero_title: "Il tour di Istanbul che sembra una giornata con un amico del posto.",
    hero_sub: "Dall'ingresso senza fila ad Hagia Sophia ai quartieri nascosti su due continenti.",
    about_eyebrow: "Su Real Istanbul Tours",
    about_title: "Tour in piccoli gruppi a Istanbul dal 2014.",
    tours_eyebrow: "I tour perfetti per la tua prima visita a Istanbul",
    tours_title: "Quattro modi indimenticabili di vivere Istanbul.",
    itinerary_eyebrow: "Cosa vedrai",
    itinerary_title: "Città Vecchia al mattino, Kadıköy per pranzo.",
    guides_eyebrow: "Le nostre guide",
    guides_title: "Persone che vivono davvero qui.",
    stops_eyebrow: "Le nostre tappe",
    stops_title: "Luoghi autentici, scelti nel tempo.",
    reviews_eyebrow: "Ciò che gli ospiti raccontano più spesso",
    reviews_title: "Una sintesi basata su oltre 7.030 recensioni verificate.",
    featured_eyebrow: "In evidenza su YouTube",
    press_eyebrow: "Real Istanbul Tours è presente su",
    faq_eyebrow: "Domande frequenti",
    faq_title: "Tutto quello che stavi per chiedere.",
    cta_title: "Vieni curioso. Al resto pensiamo noi.",
    cta_sub: "Quattro tour, una città, infinite esperienze. Non sai quale scegliere? Sfoglia tutti i nostri tour a Istanbul e trova quello perfetto per te.",
    free_cancellation: "Cancellazione gratuita entro 24h",
    instant_confirmation: "Conferma immediata",
    no_booking_fees: "Prenotazione diretta, senza commissioni",
    small_groups_max: "Piccoli gruppi, max 12 persone",
    footer_tagline: "Tour in piccoli gruppi a Istanbul dal 2014. Scopri la città con guide locali autorizzate, esplora quartieri autentici e vivi Istanbul come un locale. 4,9★ da oltre 1.000 recensioni verificate.",
    subscribe: "Iscriviti",
    contact_title: "Mettiti in contatto.",
    contact_sub: "Domande sulla prenotazione, itinerari su misura o semplicemente per salutare. Rispondiamo entro un giorno.",
    full_name: "Nome completo",
    email: "Email",
    phone: "Telefono (facoltativo)",
    subject: "Oggetto",
    message: "Messaggio",
    send_message: "Invia messaggio",
    book_this_tour: "Prenota questo tour",
    tour_date: "Data del tour",
    guests: "Numero di ospiti",
    special_requests: "Richieste speciali (facoltativo)",
    submit_booking: "Invia richiesta di prenotazione",
    blog_title: "Storie da Istanbul.",
    blog_sub: "Guide, approfondimenti gastronomici e racconti di quartiere dal nostro team.",
    read_article: "Leggi l'articolo",
  },
};
